import React from 'react';
import { DefaultDropdownProps, Dropdown } from 'framework/form';
import { getFullName } from 'domain/sales/shared/input/ownerHelper';

interface PresaleCoordinatorDropdownProps extends DefaultDropdownProps {
  coordinators: any[];
  initialCoordinatorAlias: string;
  isVisible?: boolean | undefined;
}

const PresaleCoordinatorDropdown = ({
  coordinators,
  initialCoordinatorAlias,
  ...props
}: PresaleCoordinatorDropdownProps) => {
  return (
    <Dropdown
      options={coordinators.map(coordinator => ({
        value: coordinator.alias,
        label: coordinator.nameEn && getFullName(coordinator.nameEn),
      }))}
      value={initialCoordinatorAlias}
      {...props}
    />
  );
};

export default PresaleCoordinatorDropdown;
